export const onlyDigits = (value?: string): string => {
	if (!value) return '';
	return value.replace(/\D/g, '');
};
